import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import history from '../../../../other/history';
import { memoryLike, memoryUnlike, memoryCommentSave, memoryCaptionEdit, memoryCommentsFetch, showLoginModal } from '../../../../actions/index';
import { translate } from 'react-i18next';
import { gtmSend, esCape } from '../../../../helpers';
// import style from './style.css';
import MemoryCardComponent from '../../../../components/Elems/MemoryCard';
import CommentCardComponent from '../../../../components/Common/CardComponents/Comment';
// import { ProfileThumb } from '../../../../components/Common/CardComponents';
import ReplyGenericInputModal from '../../../../components/Common/CardComponents/ReplyGenericInputModal';
import ShareModal from '../../../../components/Common/CardComponents/Share';
import { buildMapping } from '../../../../other/ActionMapper';
import { Icon } from '../../../../components/Common/Icon';
// import { myIsSet } from '../../../../helpers';
import cx from '../../../../styles';

class MemoryElemContainer extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            commentPage: 1,
            isCommentModalOpen: false, commentContent: "", modalImagePreviews: [], modalImages: [],
            isEditCaptionModalOpen: false, editCaptionContent: props.data.booth.message,
            isShareModalOpen: false,
            isLoading: false
        };
        //
        this.message = props.data.booth.message;
    }

    componentDidMount() {
        if (history.location.state && 'shouldOpenCommentDialog' in history.location.state) {
            if (history.location.state.shouldOpenCommentDialog) {
                this.openCommentModal();
            }
        }
        //
        if (history.location.state && 'shouldOpenBEditDialog' in history.location.state) {
            if (history.location.state.shouldOpenBEditDialog) {
                this.openEditCaptionModal();
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.id && nextProps.data.booth) {
            if (nextProps.data.booth.message != this.props.data.booth.message) {
                this.message = nextProps.data.booth.message;
                this.setState({ editCaptionContent: nextProps.data.booth.message });
            }
        }
    }

    goToSingleView = (state = null) => {
        history.push({
            pathname: `/booth/${this.props.id}`,
            ...(state && { state })
        });
    }

    onReplyClick = () => {
        if (!this.props.userReducer.id) {
            gtmSend('dynamic', 'Login Popup', 'open-trigged', `reply | ${this.props.match.path}` );
            gtmSend('login_popup_open', 'Login Popup', 'Open', `reply | ${this.props.match.path}`, 0, {action: 'Open'});
            this.props.showLoginModal();
        } else {
            this.props.inFeed
                ? this.goToSingleView()
                : this.openCommentModal();
            // this.goToSingleView({shouldOpenCommentDialog: true})
        }

    }

    onLikeClick = () => {
        if (!this.props.userReducer.id) {
            gtmSend('dynamic', 'Login Popup', 'open-trigged', `like | ${this.props.match.path}` );
            gtmSend('login_popup_open', 'Login Popup', 'Open', `like | ${this.props.match.path}`, 0, {action: 'Open'});
            this.props.showLoginModal();
        } else if(!this.state.isLoading) {
            const { index, inFeed, id, data } = this.props;
            gtmSend('click booth like', 'card-booth', `click:${(data.likes.liked ? 'unlike' : 'like')}`, id);
            gtmSend('cw_reaction', 'Booth Card', 'Reaction', `${(data.likes.liked ? 'unlike' : 'like')}`, 0, {card_type: 'Booth Card', card_id: `${id}`});
            if(data.likes.liked){
                this.setState({isLoading: true});
                this.props.memoryUnlike(index, inFeed, id)
                .then(() => {
                    this.setState({isLoading: false});
                });
            }
            else{
                this.setState({isLoading: true});
                this.props.memoryLike(index, inFeed, id)
                .then(() => {
                    this.setState({isLoading: false});
                });
            }
        }
    }

    openCommentModal = () => {
        this.setState({ isCommentModalOpen: true });
    }

    closeCommentModal = () => {
        this.setState({ isCommentModalOpen: false });
    }

    onCommentModalOpen = () => {
        //dialog fix
        const state = {};
        history.replace({ ...history.location, state });
    }

    onCommentModalClose = () => {
        //reset
        this.setState({ isCommentModalOpen: false, commentContent: "", modalImagePreviews: [], modalImages: [] });
    }

    onCommentModalSubmit = (e) => {
        e.preventDefault();
        const message = esCape(this.state.commentContent);
        if (!message.length) return this._addNotificationToModal(this.props.t('you_need_to_type_something'), 'error');
        // let anonymous = 0;
        // gtmSend('click booth comment', 'card-booth', 'click:comment', this.props.id);
        gtmSend('dynamic', 'Booth Comment Compose', 'click-submit', `submit:${this.props.id}`);
        gtmSend('cw_reply_submit', 'Photobooth', 'Reply Submit', 'Identified', 0, {card_type: 'Photoboth Card', card_id: `${this.props.id}`});
        this.props.memoryCommentSave(this.props.id, message)
            .then(() => {
                if(!this.props.memoryReducer.error) {
                    this.onCommentModalClose();
                }else{
                    return this._addNotificationMessageToModal(this.props.memoryReducer.error, 'error');
                }
            });
    }

    openEditCaptionModal = () => {
        this.setState({ isEditCaptionModalOpen: true });
    }

    closeEditCaptionModal = () => {
        this.setState({ isEditCaptionModalOpen: false });
    }

    onEditCaptionModalOpen = () => {
        //dialog fix
        const state = {};
        history.replace({ ...history.location, state });
    }

    onEditCaptionModalClose = () => {
        this.setState({ isEditCaptionModalOpen: false, editCaptionContent: this.props.data.booth.message });
    }

    onEditCaptionModalSubmit = (e) => {
        e.preventDefault();
        const message = esCape(this.state.editCaptionContent);
        if (!message.length) return this._addNotificationToModal(this.props.t('you_need_to_type_something'), 'error');
        // let anonymous = 0;
        gtmSend('dynamic', 'Booth Card Edit', 'click-submit', `submit:${this.props.id}`);
        this.props.memoryCaptionEdit(this.props.id, message)
            .then(() =>{
                if(!this.props.memoryReducer.error) {
                    this.closeEditCaptionModal();
                } else {
                    return this._addNotificationMessageToModal(this.props.memoryReducer.error, 'error');
                }
            });
    }

    share = () => {
        this.setState({ isShareModalOpen: true });
    }

    onMemoryCommentsFetch = () => {
        const page = this.state.commentPage;
        this.setState({commentPage: page + 1});
        this.props.memoryCommentsFetch(this.props.id, page + 1);
    }

    render() {
        const { index, inFeed, id, t, userReducer, configReducer, data } = this.props,
            booth = data.booth,
            images = data.booth.images,
            author = data.user,
            comments = data.comments,
            visibleTime = data.visible_time,
            comment_count = data.booth.comment_count,
            responseBar = {
                replyCount: comment_count,
                likes: data.likes,
                onLikeClick: this.onLikeClick,
                onReplyClick: this.onReplyClick,
                onShareClick: this.share
            },
            actions = buildMapping(
                'booth',
                data.booth.actions,
                {
                    id,
                    cardName: 'Photobooth Card',
                    authorId: author.id,
                    authorName: author.fullname,
                    subType: this.props.subType,
                    detailpage: this.props.detailpage,
                    elemRef: this,
                    inFeed,
                    t,
                    position: (typeof document != 'undefined' ? document.documentElement.scrollTop : 0)
                },
                this.context.store.dispatch
            );
        //comments
        for (const i in comments) {
            comments[i].actions = buildMapping(
                'boothComment',
                comments[i].actions,
                {
                    boothId: id,
                    id: comments[i].id,
                    authorId: comments[i].user.id,
                    authorName: comments[i].user.fullname,
                    elemRef: this,
                    inFeed,
                    t,
                    position: (typeof document != 'undefined' ? document.documentElement.scrollTop : 0)
                },
                this.context.store.dispatch
            );
        }

        return (
            <div className={cx("memory-elem-container")}>

                <div className={cx("shadow-card", "no-pad")}>
                    <MemoryCardComponent index={index}
                        booth={booth}
                        message={this.message}
                        author={author}
                        images={images}
                        actions={actions}
                        responseBar={responseBar}
                        visibleTime={visibleTime}
                        inFeed={inFeed}
                        id={id}
                        match={this.props.match}
                        cardName='Photobooth Card'
                        siteUrl={configReducer.siteUrl}
                        t={t} />
                </div>

                {
                    !inFeed && responseBar.replyCount != 0 &&
                    <h3>
                        {
                            responseBar.replyCount == 1 
                            ? 
                                `1 ${t('detail_reply_count')}` 
                            : 
                                `${responseBar.replyCount} ${t('detail_reply_count_plural')}`
                        }
                    </h3>
                }

                {
                    !inFeed &&
                    <div className={cx("no-pad", "reply-comments")}>
                        {
                            comments.map((comment, i) => {
                                return <CommentCardComponent key={i} t={t} comment={comment} imageThumbSize="small" siteUrl={configReducer.siteUrl} status={1} />;
                            })
                        }
                    </div>
                }

                {
                    !inFeed && !!data.more_comment_count &&
                    <button className="more-reply-btn" onClick={() =>this.onMemoryCommentsFetch()}>
                        {`${data.more_comment_count} ${data.more_comment_count > 1 ? t('detail_reply_count_plural') : t('detail_reply_count')}`}
                        <Icon name="dropdown-icon" />
                    </button>
                }


                {
                    !inFeed && this.state.isCommentModalOpen &&
                    <ReplyGenericInputModal isModalOpen={this.state.isCommentModalOpen}
                        eventHandlers={{
                            onModalOpen: this.onCommentModalOpen,
                            onModalClose: this.onCommentModalClose,
                            onSubmit: this.onCommentModalSubmit,
                            onImageUpload: () => { },
                            onContentChange: (v) => this.setState({ commentContent: v }),
                            refAddNotification: (f) => this._addNotificationToModal = f,
                            refAddNotificationMessage: (f) => this._addNotificationMessageToModal = f
                        }}
                        gtmLabel={'Booth Comment Compose'}
                        cardName='Photobooth Card'
                        id={id}
                        content={this.state.commentContent}
                        imagePreviews={[]}
                        user={userReducer}
                        showUploadInput={false}
                        showAnonymous={userReducer.country === 'id' ? false : true}
                        isMemory={true} />
                }

                {
                    !inFeed && this.state.isEditCaptionModalOpen &&
                    <ReplyGenericInputModal isModalOpen={this.state.isEditCaptionModalOpen}
                        eventHandlers={{
                            onModalOpen: this.onEditCaptionModalOpen,
                            onModalClose: this.onEditCaptionModalClose,
                            onSubmit: this.onEditCaptionModalSubmit,
                            onImageUpload: () => { },
                            onContentChange: (v) => this.setState({ editCaptionContent: v }),
                            refAddNotification: (f) => this._addNotificationToModal = f,
                            refAddNotificationMessage: (f) => this._addNotificationMessageToModal = f
                        }}
                        gtmLabel={'Booth Card Edit'}
                        id={id}
                        content={this.state.editCaptionContent}
                        imagePreviews={[]}
                        user={userReducer}
                        showUploadInput={false}
                        isMemory={true}
                        buttonLabel={t('add_edit_save')} />
                }

                {
                    <ShareModal isModalOpen={this.state.isShareModalOpen}
                        position={typeof document != 'undefined' ? document.documentElement.scrollTop : 0}
                        shareType='booth'
                        cardName='Photobooth Card'
                        id={id}
                        siteUrl={configReducer.siteUrl}
                        slug={`booth/${id}`}
                        username={userReducer.full_name}
                        t={t}
                        onModalClose={() => this.setState({ isShareModalOpen: false })} />
                }

            </div>
        );
    }

}

MemoryElemContainer.contextTypes = {
    store: PropTypes.object.isRequired
};

//map state
const mapStateToProps = (state) => {
    // console.log(state);
    return state;
};

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        memoryLike,
        memoryUnlike,
        memoryCommentSave,
        memoryCaptionEdit,
        memoryCommentsFetch,
        showLoginModal
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(MemoryElemContainer));
